import { render } from "./SettingsPracticeDetails.vue?vue&type=template&id=40c95b96"
import script from "./SettingsPracticeDetails.vue?vue&type=script&lang=js"
export * from "./SettingsPracticeDetails.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__